import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  isLoadingMasterConfiguration: false,
  masterConfiguration: [],
};

export const setMasterConfiguration: any = createAsyncThunk(
  "content/setMasterConfiguration",
  async ({
    operationName,
    id = 0,
    profileName = null,
    startTime = null,
    endTime = null,
    status = 0,
    zoneId = 0,
    dayOfWeek = 0,
    actionId = 0,
    dimLevel = 0,
    brightLevel = 0,
    luminanceLevel = 0,
    startDate = null,
    endDate = null,
    dimThreshold = 0,
    brightThreshold = 0,
    brightActionId = 0,
    dimActionId = 0,
    photoSensor = null,
    rainSensor = null,
    repeatAction = 0,
    lightRainThreshold = 0,
    heavyRainThreshold = 0,
    lightRainActionId = 0,
    heavyRainActionId = 0,
    maxLuminance = 0,
    minLuminance = 0,
    dayLightThreshold = 0,
    name = "",
    operationModeId = 0,
    failSafeDelay = null,
    rampUpTime = null,
    rampDownTime = null,
    timeDelay = 0,
    detectionRangeId = 0,
    photoLowerThreshold = 0,
    photoUpperThreshold = 0,
    photoSensing = true,
    isEnabled = true,
    rainLowerThreshold = 0,
    rainUpperThreshold = 0,
    rainSensing = true,
    photoMonitoringInterval = 0,
    rainMonitoringInterval = 0,
  }: any) => {
    const res = await axios.post(
      `/slpapp/baseconfiguration/set`,
      {
        operationName,
        id,
        profileName,
        startTime,
        endTime,
        status,
        zoneId,
        dayOfWeek,
        actionId,
        dimLevel,
        brightLevel,
        luminanceLevel,
        startDate,
        endDate,
        dimThreshold,
        brightThreshold,
        brightActionId,
        dimActionId,
        photoSensor,
        rainSensor,
        repeatAction,
        lightRainThreshold,
        heavyRainThreshold,
        lightRainActionId,
        heavyRainActionId,
        maxLuminance,
        minLuminance,
        dayLightThreshold,
        name,
        operationModeId,
        failSafeDelay,
        rampUpTime,
        rampDownTime,
        timeDelay,
        detectionRangeId,
        photoLowerThreshold,
        photoUpperThreshold,
        photoSensing,
        isEnabled,
        rainLowerThreshold,
        rainUpperThreshold,
        rainSensing,
        photoMonitoringInterval,
        rainMonitoringInterval,
      },
      {
        params: {
          operationName: operationName,
        },
      }
    );
    const data = await res.data;

    return data;
  }
);

export const masterConfigurationSlice = createSlice({
  name: "masterConfiguration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setMasterConfiguration.pending, (state) => {
      state.isLoadingMasterConfiguration = true;
    });
    builder.addCase(setMasterConfiguration.fulfilled, (state, action) => {
      state.isLoadingMasterConfiguration = false;
      state.masterConfiguration = action.payload;
    });
    builder.addCase(setMasterConfiguration.rejected, (state, action) => {
      state.isLoadingMasterConfiguration = false;
      state.error = action.error.message;
    });
  },
});

export default masterConfigurationSlice.reducer;
